/**
 * More precise round than Math.round
 * examples:
 *  * 1.005 to 2 decimals -> 1.01
 *  * 1.9 to 0 decimals -> 2
 *  * 1.87 to 2 decimals -> 1.87
 *  * 1.87 to 1 decimals -> 1.9
 * 
 * @param number number
 * @param decimals number, integer non-negative
 * @returns number
 */
export function round(number: number, decimals: number): number {
  if (!Number.isInteger(decimals) || decimals < 0) {
    throw new Error("'decimal' parameter must be a non-negative integer")
  }
  return +(Math.round(Number(number + `e+${decimals}`)) + `e-${decimals}`)
}
